module.exports = __webpack_public_path__ + "img/34h-config-modelos-doc-wizard-textos.27704ae6.png";